export function scrollToSection(id: string): void {
  const sectionId = id.toLowerCase().replace(/\s+/g, '-');
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
